import React from "react";
import { Link } from "react-router-dom";

import logoIPB from "./../resources/img/logoIPB_black.svg";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footerContent">
        <img src={logoIPB} alt="logoIPB" />
        <div className="redesSociais">
          <a
            href="https://ipbnews.ipb.pt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-square"></i>
          </a>
          <a
            href="https://ipbnews.ipb.pt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram-square"></i>
          </a>
          <a
            href="https://ipbnews.ipb.pt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://ipbnews.ipb.pt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-youtube"></i>
          </a>
        </div>
        <Link to="/">ipbnews.ipb.pt</Link>
      </div>
    </div>
  );
}
